import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CoreModule } from '@core/core.module';
import { NotesModule } from '@notes/notes.module';
import { ProjectModule } from '../project/project.module';
import { IConfig, NgxMaskDirective, NgxMaskPipe, provideEnvironmentNgxMask } from 'ngx-mask';

import { HeaderComponent } from './header/header.component';
import { CarrierSearchResultsComponent } from './quick-search/carrier-search-results/carrier-search-results.component';
import { CarrierFullProfileModule } from '../carrier-full-profile/carrier-full-profile.module';
import { CoreTasksModule } from '../broker/tasks/core-tasks/core-tasks.module';

import { HighlightTextPipe } from '@shared/highlight-text.pipe';
import { UploadCsvModule } from '../upload-csv/upload-csv.module';
import { QuickSearchComponent } from './quick-search/quick-search.component';
import { ProjectSearchResultsComponent } from './quick-search/project-search-results/project-search-results.component';
import { SharedModule } from '@shared/shared.module';
import { NotificationPopoverComponent } from './notification-popover/notification-popover.component';
import { ProfilePopoverComponent } from './profile-popover/profile-popover.component';
import { BrokerSearchResultsComponent } from './quick-search/broker-search-results/broker-search-results.component';
import { MtxPopoverModule } from '@ng-matero/extensions/popover';
import { NotificationsComponent } from '../v2/components/notifications/notifications.component';
import { ScrollingModule } from '@angular/cdk/scrolling';

const maskConfig: Partial<IConfig> = {};

const imports = [];

const components = [
	HeaderComponent,
	QuickSearchComponent,
	CarrierSearchResultsComponent,
	ProjectSearchResultsComponent,
	NotificationPopoverComponent,
	ProfilePopoverComponent,
	BrokerSearchResultsComponent,
	NotificationsComponent,
];

const pipes = [HighlightTextPipe];

@NgModule({
	declarations: [components, pipes],
	imports: [
		CommonModule,
		CoreModule,
		NotesModule,
		ProjectModule,
		CarrierFullProfileModule,
		CoreTasksModule,
		UploadCsvModule,
		SharedModule,
		MtxPopoverModule,
		ScrollingModule,
		NgxMaskDirective,
		NgxMaskPipe,
	],
	exports: [...imports, ...components],
	providers: [provideEnvironmentNgxMask(maskConfig)],
})
export class HeaderModule {}
